import { nanoid } from 'nanoid';
import Combobox from './combobox.jsx';

export function AddressAutocomplete(props) {
    const { query, handleChangeQuery, handleSetValue, options, autoFocus } = props;
    return (
        <Combobox.Full
            label={_t.global.search()}
            inPortal={false}
            query={query}
            onQueryChange={handleChangeQuery}
            onChange={handleSetValue}
            displayValue={(opt) => opt.label}
            makeReactKey={() => nanoid()}
            placeholder={_t.edit.placeholders.address()}
            options={options}
            filterFn={() => true}
            nullable={true}
            autoFocus={autoFocus}
        />
    );
}
